<script setup lang="ts">
import { useStorage } from '@vueuse/core'
import { ClipboardList } from 'lucide-vue-next'

const surveyButton = useStorage('survey-button', false)

const mainStore = useMainStore()
</script>

<template>
  <div>
    <Header critical />
    <main class="pt-20 -scroll-mt-20">
      <slot />
    </main>
    <Footer />
    <FeedbackModal v-model="mainStore.feedbackOpen" />
    <ClientOnly>
      <div v-if="surveyButton" v-auto-animate class="fixed bottom-24 right-5 z-50">
        <NuxtLink
          to="/survey"
          title="Пройти опрос"
        >
          <button
            style="background: linear-gradient(95deg, rgb(33, 150, 243) 20%, rgb(33, 150, 243) 80%);"
            class="border-none text-white relative group rounded-full mx-auto shadow-lg size-[60px] md:size-[65px] hover:cursor-pointer"
          >
            <ClipboardList class="size-[35px] mx-auto my-auto" />
          </button>
        </NuxtLink>

        <button
          class="absolute top-[-5px] right-[-5px] p-1 rounded-full bg-accent/60 transition-colors hover:cursor-pointer hover:bg-accent/80"
          @click="surveyButton = false"
        >
          <svg
            class="h-4 w-4 text-muted-foreground"
            viewBox="0 0 16 16"
            fill="currentColor"
          >
            <path
              d="M2.96967 2.96967C3.26256 2.67678 3.73744 2.67678 4.03033 2.96967L8 6.939L11.9697 2.96967C12.2626 2.67678 12.7374 2.67678 13.0303 2.96967C13.3232 3.26256 13.3232 3.73744 13.0303 4.03033L9.061 8L13.0303 11.9697C13.2966 12.2359 13.3208 12.6526 13.1029 12.9462L13.0303 13.0303C12.7374 13.3232 12.2626 13.3232 11.9697 13.0303L8 9.061L4.03033 13.0303C3.73744 13.3232 3.26256 13.3232 2.96967 13.0303C2.67678 12.7374 2.67678 12.2626 2.96967 11.9697L6.939 8L2.96967 4.03033C2.7034 3.76406 2.6792 3.3474 2.89705 3.05379L2.96967 2.96967Z"
            />
          </svg>
        </button>
      </div>
    </ClientOnly>
  </div>
</template>

<style scoped>

</style>
